// notification.service.ts
import { Injectable, signal } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { environment } from 'src/environments/environment'
import { ToastrService } from 'ngx-toastr'

@Injectable({ providedIn: 'root' })
export class NotificationService {
  // Signal  for the notification  list
  _notificationsState = signal({ totalCount: 0, paginationCount: 0, data: {} })
  notificationsState = this._notificationsState.asReadonly()
  notifications = signal<any[]>([])
  unreadCount = signal<number>(0)

  // Signal for the header menu
  _menuNotifications = signal<any[]>([])
  menuNotifications = this._menuNotifications.asReadonly()
  // Messaging instance from the vanilla SDK (default app initialized in main.ts).
  private messaging = getMessaging()

  constructor(
    private http: HttpClient,
    private toastr: ToastrService
  ) {}
  requestPermission() {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        navigator.serviceWorker.ready.then((registration) => {
          getToken(this.messaging, {
            vapidKey: environment.firebaseConfig.vapidKey,
            serviceWorkerRegistration: registration
          })
            .then((token) => {
              this.udateFCMToken(token)
            })
            .catch(() => {})
        })
      }
    })
  }

  listenForMessages() {
    onMessage(this.messaging, (payload) => {
      const title = payload.notification?.title || 'Notification'
      const body = payload.notification?.body || ''

      this.toastr.info(body, title)

      this.getNotifactions({ pageIndex: 1, pageSize: 10 })
    })
  }

  readNotification(id: number) {
    this.http.post(`Notification/ReadNotification/${id}`, {}).subscribe(() => {
      this.notifications.update((curr) =>
        curr.map((n) => (n.id === id ? { ...n, isRead: true } : n))
      )
      this.unreadCount.set(this.notifications().filter((n) => !n.isRead).length)
    })
  }

  readAllNotifications() {
    this.http.post('Notification/ReadAllNotifications', {}).subscribe(() => {
      this.notifications.update((curr) =>
        curr.map((n) => ({ ...n, isRead: true }))
      )
      this.unreadCount.set(0)
    })
  }
  udateFCMToken(token: any) {
    return this.http.post(`User/UpdateFCMToken?token=${token}`, {}).subscribe()
  }

  getNotifactions(data: any) {
    this.http.post('Notification/GetNotifications', data).subscribe({
      next: (res: any) => {
        const data = res?.Data ?? {}
        const items = data?.items ?? []

        // Update full state

        this._notificationsState.set({
          totalCount: data.totalcount || 0,
          paginationCount: data.paginationCount || 0,
          data: data?.items ?? {}
        })
        this.notifications.set(items)
        this.unreadCount.set(items.filter((n: any) => !n.isRead).length)
      }
    })
  }

  getUnreadNotifactions(data: any) {
    return this.http.post('Notification/GetUnreadNotifications', data)
  }

  getMenuNotifications() {
    const headerParams = { pageIndex: 1, pageSize: 10 }

    this.http.post('Notification/GetNotifications', headerParams).subscribe({
      next: (res: any) => {
        const data = res?.Data ?? {}
        const items = data?.items ?? []

        this._menuNotifications.set(items)

        this.unreadCount.set(items.filter((n: any) => !n.isRead).length)
      }
    })
  }
}
